import * as React from "react"
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { Grid } from "../ecosystem/";
import { CircleButtonCard, PageHeading } from "../ecosystem/mybswh";

const GetCareLanding = (props) => {

    const { hasMyChart, clearSearch } = props;

    const onClickgetCareTile = (tileName, routeName) => {
        logUI(`MBHWeb.UI.GetCareLanding.${tileName}.Clicked`, new Date(), Tools.getURLPath());
        if (routeName) {
            props.history.push(routeName);
        }
    };

    return (
        <Grid className="body-content get-care-container">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <PageHeading heading="Schedule & Search" />
                    <div className="row">
                        <div className="col-12 col-lg-6">
                            <CircleButtonCard
                                cardIcon={{ name: 'calendar' }}
                                titleStyle={{ bold: true, type: "heading-02" }}
                                disabled={!hasMyChart}
                                to={"/schedulenow"}
                                onClick={() => { onClickgetCareTile("Schedulenow") }}
                                title="Schedule Now"
                                body="Book an appointment with your doctor, schedule a video visit, and more."
                            />
                        </div>
                        <div className="col-12 col-lg-6">
                            <CircleButtonCard
                                cardIcon={{ name: 'find-care' }}
                                titleStyle={{ bold: true, type: "heading-02" }}
                                to={"/findcare"}
                                onClick={() => {
                                    onClickgetCareTile("FindCare");
                                    clearSearch();
                                }}
                                title="Find Care"
                                body="Search for the right doctor, location, or type of care for you."
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Grid>

    )
}

const mapStateToProps = (state) => {
    return {
        hasMyChart: state.domain.hm
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearSearch: () => {
            dispatch({ type: types.SEARCH_PROVIDER_CLEAR });
            dispatch({ type: types.SEARCH_LOCATION_CLEAR });
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GetCareLanding));
